import api from './axios';

//마이페이지 - 공통 - 공통코드 콤보박스 가져오기
export const fetchCommonComboList = async (params) => {
  const response = await api.get('/knouUser/mypage/getCommonSelectList', params);
  return response.data;
};

//마이페이지 - 나의수강강좌 - 콤보박스 가져오기
export const fetchMyCourseComboList = async (params) => {
  const response = await api.get('/knouUser/mypage/getMyCourseComboList', params);
  return response.data;
};

//마이페이지 - 나의수강강좌 - 메인리스트 가져오기
export const fetchMyCourseList = async (params) => {
  const response = await api.get('/knouUser/mypage/getMyCourseList', params);
  return response.data;
};

//마이페이지 - 나의수강강좌 - 메인리스트 가져오기
export const updateCancelState = async (params) => {
  const response = await api.post('/knouUser/mypage/updateCancelState', params);
  return response.data;
};



//마이페이지 - 나의수강강좌 - 상세 selectbox 가져오기
export const fetchMyCourseDetailComboList = async (params) => {
  const response = await api.get('/knouUser/mypage/getMyCourseDetailComboList', params);
  return response.data;
};

//마이페이지 - 나의수강강좌 - 강의리스트 가져오기
export const fetchMyCourseLectureList = async (params) => {
  const response = await api.get('/knouUser/mypage/getMyCourseLectureList', params);
  return response.data;
};

//마이페이지 - 나의수강강좌 - 강좌 소개
export const fetchMyCourseLectureIntroduce = async (params) => {
  const response = await api.get('/knouUser/mypage/getMyCourseIntroduce', params);
  return response.data;
};

//마이페이지 - 나의수강강좌 - 공지사항리스트 가져오기
export const fetchMyCourseNoticeList = async (params) => {
  const response = await api.get('/knouUser/mypage/getMyCourseNoticeList', params);
  return response.data;
};

//마이페이지 - 나의수강강좌 - 공지사항 상세정보 가져오기
export const fetchMyCourseNoticeDetail = async (params) => {
  const response = await api.get('/knouUser/mypage/getMyCourseNoticeDetail', params);
  return response.data;
};

//마이페이지 - 나의 문의 - 메인리스트 가져오기
export const fetchMyInquiryList = async (params) => {
  const response = await api.get('/knouUser/mypage/getMyInquiryList', params);
  return response.data;
};

//마이페이지 - 나의 문의 - 상세내역 가져오기
export const fetchMyInquiryDetail = async (params) => {
  const response = await api.get('/knouUser/mypage/getMyInquiryDetail', params);
  return response.data;
};

//마이페이지 - 강좌관리 - 메인리스트 가져오기
export const fetchMyManagementList = async (params) => {
  const response = await api.get('/knouUser/mypage/getMyManagementList', params);
  return response.data;
};

//마이페이지 - 강좌관리 - 상세 selectbox 가져오기
export const fetchMyManagementComboList = async (params) => {
  const response = await api.get('/knouUser/mypage/getMyManagementComboList', params);
  return response.data;
};

//마이페이지 - 강좌관리 - 강좌요약 - 수치데이터 가져오기
export const fetchMyManagementDetailStatistics = async (params) => {
  const response = await api.get('/knouUser/mypage/getMyManagementAggregate', params);
  return response.data;
};

//마이페이지 - 강좌관리 - 수강자목록가져오기
export const fetchMyManagementDetail = async (params) => {
  const response = await api.get('/knouUser/mypage/getMyManagementDetail', params);
  return response.data;
};

//마이페이지 - 강좌관리 - 강좌정보(섹션포함)가져오기
export const fetchMyManagementLectureList = async (params) => {
  const response = await api.get('/knouUser/mypage/getMyManagementLectureList', params);
  return response.data;
};

//마이페이지 - 나의 문의 - 메인리스트 가져오기
export const fetchMngQnaList = async (params) => {
  const response = await api.get('/knouUser/mypage/getMngQnaList', params);
  return response.data;
};

//마이페이지 - 나의 문의 - 상세내역 가져오기
export const fetchMngQnaDetail = async (params) => {
  const response = await api.get('/knouUser/mypage/getMngQnaDetail', params);
  return response.data;
};

export const insertMyQuestionData = async (formData) => {
  const response = await api.post('/knouUser/mypage/insertMyQuestion', formData);
  // const response = await api.post('/knouUser/mypage/insertMyQuestion', formData, {
  //   headers: {
  //     'Content-Type': 'multipart/form-data',
  //   },
  // });
  return response.data;
};

//마이페이지 - 나의 관심컨텐츠 - 목록
export const fetchMyContentsConcernList = async (params) => {
  const response = await api.get('/knouUser/mypage/getMyContentsConcernList', params);
  return response.data;
};

//마이페이지 - 나의 관심컨텐츠 - 관심컨텐츠 제외
export const deleteMyContentsConcern = async (params) => {
  const response = await api.post('/knouUser/mypage/deleteMyContentsConcern', params);
  return response.data;
};

//마이페이지 - 나의 관심컨텐츠 - 관심컨텐츠 등록
export const insertMyContentsConcern = async (params) => {
  const response = await api.post('/knouUser/mypage/insertMyContentsConcern', params);
  return response.data;
};

//마이페이지 - 내가 본 컨텐츠 - 목록
export const fetchMyContentsHistoryList = async (params) => {
  const response = await api.get('/knouUser/mypage/getMyContentsHistoryList', params);
  return response.data;
};

//마이페이지 - pk값 가져오기
export const getTsid = async (params) => {
  const response = await api.get('/knouUser/mypage/getTsid', params);
  return response.data;
};



// GET /users/:id
export const fetchUserById = async (id) => {
  const response = await api.get(`/users/${id}`);
  return response.data;
};

// POST /users
export const createUser = async (userData) => {
  const response = await api.post('/users', userData);
  return response.data;
};